/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsTicketLogDto } from '../../models/as-ticket-log-dto';

export interface AsControllerGetVendorTicketLogs$Params {
  clientWorkspaceId: string;
  ticketId: string;
}

export function asControllerGetVendorTicketLogs(http: HttpClient, rootUrl: string, params: AsControllerGetVendorTicketLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AsTicketLogDto>>> {
  const rb = new RequestBuilder(rootUrl, asControllerGetVendorTicketLogs.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AsTicketLogDto>>;
    })
  );
}

asControllerGetVendorTicketLogs.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}/logs';
